export default __webpack_public_path__ + "static/media/figma.152e5532.png";